import { Button } from 'react-bootstrap';
import axios from 'axios';
import React from 'react';

import { useGlobalContext } from '../context';
import Score from '../components/Score';
import Units from '../components/Units';
import { toast } from 'react-toastify';

const Learn = () => {
  // const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const { lessonState, data, setData } = useGlobalContext();

  //console.log(lessonState);

  let url;

  // console.log(url);

  const nextQuestionHandler = async () => {
    setLoading(true);

    try {
      if (lessonState === 0) {
        url = 'https://jap-vocab-n2.herokuapp.com/api/v1/questions/learn/learn';
      } else {
        url = `https://jap-vocab-n2.herokuapp.com/api/v1/questions/learn/learn/${lessonState}`;
      }
      const questions = await axios.get(url);
      // console.log(questions);
      setData(questions.data.randomQuestion);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  // console.log(data);
  const Question = () => {
    return (
      <div
        className="flex fs-500 ff-serif "
        style={{ flexDirection: 'column', gap: '3rem', marginTop: '3rem' }}
      >
        <div> {data.jap} </div> <div> {data.eng} </div>{' '}
      </div>
    );
  };

  return (
    <div
      className="flex main"
      style={{ flexDirection: 'column', paddingTop: '20px' }}
    >
      <section
        className="flex game-holder  "
        style={{ flexDirection: 'row', gap: '0.5rem' }}
      >
        <Units />
        <section
          className="flex game-holder"
          style={{
            flexDirection: 'column',

            alignItems: 'center',
          }}
        >
          <div
            className="flex"
            style={{
              flexDirection: 'row',
              justifyItems: 'stretch',
              gap: '1rem',
              flexWrap: 'wrap',
            }}
          >
            <Button
              variant="secondary"
              className="btn-100 go"
              onClick={() => nextQuestionHandler()}
            >
              Go!
            </Button>{' '}
            <Score />
          </div>{' '}
          {loading && <div> LOADING... </div>} {data && <Question />}{' '}
        </section>{' '}
      </section>{' '}
    </div>
  );
};

export default Learn;
